/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CardTypeConfigurationDTO,
    CardTypeConfigurationDTOFromJSON,
    CardTypeConfigurationDTOToJSON,
    CardTypeDTO,
    CardTypeDTOFromJSON,
    CardTypeDTOToJSON,
    UpdateCardTypeDTO,
    UpdateCardTypeDTOFromJSON,
    UpdateCardTypeDTOToJSON,
} from '../models';

export interface AddCardTypeRequest {
    cardTypeDTO: CardTypeDTO;
}

export interface GetAvailableCardTypesRequest {
    carePrincipalId: string;
}

export interface GetCardTypeConfigurationsRequest {
    carePrincipalId: string;
}

export interface RemoveCardTypeRequest {
    cardTypeId: string;
}

export interface UpdateCardTypeConfigurationRequest {
    carePrincipalId: string;
    updateCardTypeDTO: Array<UpdateCardTypeDTO>;
}

/**
 * 
 */
export class CardTypeApi extends runtime.BaseAPI {

    /**
     */
    async addCardTypeRaw(requestParameters: AddCardTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.cardTypeDTO === null || requestParameters.cardTypeDTO === undefined) {
            throw new runtime.RequiredError('cardTypeDTO','Required parameter requestParameters.cardTypeDTO was null or undefined when calling addCardType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/cardtype`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CardTypeDTOToJSON(requestParameters.cardTypeDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addCardType(cardTypeDTO: CardTypeDTO, initOverrides?: RequestInit): Promise<void> {
        await this.addCardTypeRaw({ cardTypeDTO: cardTypeDTO }, initOverrides);
    }

    /**
     */
    async getAllCardTypeConfigurationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CardTypeConfigurationDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/cardtype/configurations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CardTypeConfigurationDTOFromJSON));
    }

    /**
     */
    async getAllCardTypeConfigurations(initOverrides?: RequestInit): Promise<Array<CardTypeConfigurationDTO>> {
        const response = await this.getAllCardTypeConfigurationsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAvailableCardTypesRaw(requestParameters: GetAvailableCardTypesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CardTypeDTO>>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getAvailableCardTypes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/cardtypes/{carePrincipalId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CardTypeDTOFromJSON));
    }

    /**
     */
    async getAvailableCardTypes(carePrincipalId: string, initOverrides?: RequestInit): Promise<Array<CardTypeDTO>> {
        const response = await this.getAvailableCardTypesRaw({ carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCardTypeConfigurationsRaw(requestParameters: GetCardTypeConfigurationsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CardTypeConfigurationDTO>>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getCardTypeConfigurations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/cardtype/configurations`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CardTypeConfigurationDTOFromJSON));
    }

    /**
     */
    async getCardTypeConfigurations(carePrincipalId: string, initOverrides?: RequestInit): Promise<Array<CardTypeConfigurationDTO>> {
        const response = await this.getCardTypeConfigurationsRaw({ carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCardTypesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CardTypeDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/cardtypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CardTypeDTOFromJSON));
    }

    /**
     */
    async getCardTypes(initOverrides?: RequestInit): Promise<Array<CardTypeDTO>> {
        const response = await this.getCardTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async removeCardTypeRaw(requestParameters: RemoveCardTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.cardTypeId === null || requestParameters.cardTypeId === undefined) {
            throw new runtime.RequiredError('cardTypeId','Required parameter requestParameters.cardTypeId was null or undefined when calling removeCardType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/cardtype/{cardTypeId}`.replace(`{${"cardTypeId"}}`, encodeURIComponent(String(requestParameters.cardTypeId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeCardType(cardTypeId: string, initOverrides?: RequestInit): Promise<void> {
        await this.removeCardTypeRaw({ cardTypeId: cardTypeId }, initOverrides);
    }

    /**
     */
    async updateCardTypeConfigurationRaw(requestParameters: UpdateCardTypeConfigurationRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling updateCardTypeConfiguration.');
        }

        if (requestParameters.updateCardTypeDTO === null || requestParameters.updateCardTypeDTO === undefined) {
            throw new runtime.RequiredError('updateCardTypeDTO','Required parameter requestParameters.updateCardTypeDTO was null or undefined when calling updateCardTypeConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/cardtype/configuration`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateCardTypeDTO.map(UpdateCardTypeDTOToJSON),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async updateCardTypeConfiguration(carePrincipalId: string, updateCardTypeDTO: Array<UpdateCardTypeDTO>, initOverrides?: RequestInit): Promise<string> {
        const response = await this.updateCardTypeConfigurationRaw({ carePrincipalId: carePrincipalId, updateCardTypeDTO: updateCardTypeDTO }, initOverrides);
        return await response.value();
    }

}
